import { useState } from "react";
import { useDispatch } from "react-redux";
import { changeSelectedRoute } from "../../../redux/navmode.action";
import AllRouteComponent from "./AllRouteComponent";
import DetailRouteComponent from "./DetailRouteComponent";

const RoutesSection = () => {
  const [isOpenDetailRoute, setIsOpenDetailRoute] = useState(false);

  const dispatch = useDispatch();

  return (
    <>
      {isOpenDetailRoute ? (
        <DetailRouteComponent
          setIsOpenDetailRoute={(isOpen: boolean) => {
            setIsOpenDetailRoute(isOpen);

            if (!isOpen) {
              dispatch(changeSelectedRoute(null));
            }
          }}
        />
      ) : (
        <AllRouteComponent setIsOpenDetailRoute={setIsOpenDetailRoute} />
      )}
    </>
  );
};

export default RoutesSection;
